'use client';

import { c as _c } from "react/compiler-runtime";
import type { SetStateAction } from 'react';
import { FiltersState } from '../core';
import { dataTableFiltersParser } from '../../query-parsers';
import { useTableQueryState } from '../../table/hooks/use-table-query-state.ts';
export { dataTableFiltersParser } from '../../query-parsers';

// A table whose older links need upgrading passes its own parser.
export const useDataTableFiltersQuery = t0 => {
  const $ = _c(7);
  const parser = t0 === undefined ? dataTableFiltersParser : t0;
  let t1;
  if ($[0] !== parser) {
    t1 = {
      filters: parser
    };
    $[0] = parser;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    setValuesAndResetPage,
    values
  } = useTableQueryState(t1);
  let t2;
  if ($[2] !== setValuesAndResetPage) {
    t2 = update => setValuesAndResetPage(oldValues => ({
      filters: typeof update === "function" ? update(oldValues.filters) : update
    }));
    $[2] = setValuesAndResetPage;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const setFilters = t2;
  let t3;
  if ($[4] !== setFilters || $[5] !== values.filters) {
    t3 = {
      filters: values.filters,
      setFilters
    };
    $[4] = setFilters;
    $[5] = values.filters;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};